import * as React from "react";
import { Cascader } from "antd";
import { connect } from "react-redux";
import { getOrderPayStatus } from "utils/enum/orderListFormEnum";

interface ITradingCascaderProps {
  width?: number;
  setValue?: any;
  share?: any;
  // 默认值
  defaultValue?: any;
  value?: any;
  style?: React.CSSProperties;
  // 自定义字段，映射viewModel的字段
  "data-field"?: any;
  "second-field"?: any;
  modelName?: any;
  onChange?: any;
  // redux中管理的表单数据
  reduxFormData?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
}

// 交易状态
class TradingCascader extends React.Component<ITradingCascaderProps, any> {
  state = {
    value: [],
    first: "",
    second: "",
    // 获取订单交易状态数据
    options: getOrderPayStatus("label", "value")
  };

  constructor(props: ITradingCascaderProps) {
    super(props);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const reduxFormData = nextProps.reduxFormData;
    // 清空数据
    if (!reduxFormData[nextProps.modelName][nextProps["second-field"]]) {
      return {
        value: []
      };
    } else return prevState;
  }

  // 选完数据后触发
  onChange = (value, selectedOptions) => {
    let data = {},
      first = value[0],
      second = "";

    if (value.length == 2) {
      data[this.props["first-field"]] = value[0];
      data[this.props["second-field"]] = value[1];
      second = value[1];
    } else {
      data[this.props["first-field"]] = value[0];
      data[this.props["second-field"]] = "";
    }

    this.props.setValue({
      formInfo: data,
      model: this.props.modelName
    });

    this.setState({
      first: first,
      second: second
      //value: [first, second]
    });
    console.log("选中交易状态的值", [first, second]);
  };

  filter = (inputValue, path) => {
    return path.some(
      option =>
        option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
    );
  };

  getContainer = () => {
    const containerBody = this.props.containerBody;
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };

  render() {
    // const first = this.state.first,
    //   second = this.state.second;

    // let value: any = [];
    // if (first || second) {
    //   value = [first, second];
    // }

    let value: any = [];
    const first = this.props.reduxFormData[this.props.modelName][
        this.props["first-field"]
      ],
      second = this.props.reduxFormData[this.props.modelName][
        this.props["second-field"]
      ];

    if (first || second) {
      value = [first, second];
    } else {
      value = [];
    }

    return (
      <Cascader
        options={this.state.options}
        value={value}
        onChange={this.onChange}
        style={{ width: this.props.width || 220 }}
        changeOnSelect={true}
        showSearch={{ filter: this.filter }}
        placeholder="交易状态"
        getPopupContainer={this.getContainer}
      />
    );
  }
}

const mapState = state => ({
  reduxFormData: state.antDemo
});

const mapDispatch = dispatch => {
  return {
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(TradingCascader);
